import { defineStore } from 'pinia'
import { getStudentInfo, getTeacherInfo } from '@/api/user'
import { getUserInfo, logout } from '@/api/login/index'
import { getBookReadHistory } from '@/api/home/index.js'
import Config from '@/utils/Config.js'
import { getToken } from '@/utils/auth'
import { useSchoolStore } from '@/stores/School.js'
export default defineStore({
  id: 'User',
  state: () => ({
    userInfo: null,
    userRoles: [],
    userToken: null,
    ltiToken: null,
    ltiCursorInfo: {},
    readHistoryList: [],
    studentInfo: null,
  }),
  getters: {
    getUserToken: state => state.userToken,
    UserInfo: state => state.userInfo,
    UserRoles: state => state.userRoles,
    UserReadHistory: state => state.readHistoryList,
    StudentInfo: state => state.studentInfo,
  },
  actions: {
    GetToken(token = null) {
      window.localStorage.setItem(Config.tokenKey, token || '')
      this.userToken = token
    },
    GetLTIToken(token = null) {
      window.localStorage.setItem('LTI_TOKEN', token || '')
      this.ltiToken = token
    },
    GetLTICursorInfo(cursorInfoString = '') {
      if (!cursorInfoString) return

      const [
        courseCode,
        schoolYear,
        termName,
        courseName,
      ] = cursorInfoString.split('-')

      const cursorInfo = {
        courseCode,
        schoolYear,
        termName,
        courseName,
      }

      window.localStorage.setItem('LTI_CURSOR', JSON.stringify(cursorInfo))
      this.ltiCursorInfo = cursorInfo || {}
    },
    async GetUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(res => {
            let userInfo, userRoles

            if (res.code === 200) {
              userInfo = res.user
              userRoles = res.roles || []
              if (userRoles.length === 0) {
                userRoles = ['']
              }
            } else {
              userInfo = null
              userRoles = []
            }
            this.userInfo = userInfo
            this.userRoles = userRoles

            window.localStorage.setItem('USER_INFO', JSON.stringify(userInfo))
            resolve(res)
          }).catch(e => {
            this.userInfo = null
            this.userRoles = []
            reject(e)
          })
      })
    },
    async GetStudentInfo() {
      return new Promise((resolve, reject) => {
        getStudentInfo()
          .then(res => {
            this.studentInfo = res.studentInfo
            const token = getToken()

            window.localStorage.setItem(Config.tokenKey, token || '')
            window.localStorage.removeItem('TOKEN')
            resolve(res)
          }).catch(e => {
            reject(e)
          })
      })
    },
    async GetTeacherInfo() {
      return new Promise((resolve, reject) => {
        getTeacherInfo()
          .then(res => {
            this.studentInfo = res.teacherInfo
            const token = getToken()

            window.localStorage.setItem(Config.tokenTeacherKey, token || '')
            window.localStorage.removeItem('TOKEN')
            resolve(res)
          }).catch(e => {
            reject(e)
          })
      })
    },
    GetReadHistoryList() {
      return new Promise((resolve, reject) => {
        getBookReadHistory({})
          .then(res => {
            this.readHistoryList = res.rows || []
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    LogOut() {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          this.userToken = null
          this.userInfo = null
          this.readHistoryList = []
          this.studentInfo = null
          this.userRoles = []
          useSchoolStore().clearSchoolConfig()

          // 移除token
          window.localStorage.removeItem('TOKEN')
          window.localStorage.removeItem(Config.tokenKey)
          window.localStorage.removeItem(Config.tokenTeacherKey)
          window.localStorage.removeItem('USER_INFO')

          const loginType = window.localStorage.getItem('loginType')

          if (loginType === 'sso') {
            const baseUrl = 'https://sso.xjtlu.edu.cn'

            window.location.href = `${baseUrl}/logout?service=${window.location.origin}${import.meta.env.VITE_APP_LOGIN}`
          } else if (loginType === 'saml') {
            const samlLogoutUrl = import.meta.env.VITE_APP_SAML_LOGOUT_URL
            if (samlLogoutUrl) {
              window.location.href = `${samlLogoutUrl}?service=${encodeURIComponent(window.location.origin + import.meta.env.VITE_APP_LOGIN)}`
            } else {
              window.location.href = `${window.location.origin}${import.meta.env.VITE_APP_LOGIN}`
            }
          } else {
            window.location.href = `${window.location.origin}${import.meta.env.VITE_APP_LOGIN}`
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
})
